export const Demo = (flujax) => ({
  resetDemoEnvironment () {
    return flujax.post('/demo/resetDemoEnvironment')
  }
})
